import AuditCompanyFSCategoryList from "@/pages/components/manage/category/co-fs-cate/AuditCompanyFSCategoryList";

export default {
  list: AuditCompanyFSCategoryList,
};
